/**
 * Один запрос на всех, кто попросил одновременно.
 *
 * Проверка `if (isLoading) return` эту задачу НЕ решает: второй вызывающий
 * получает мгновенно разрешённый `undefined` и идёт дальше, когда данных
 * ещё нет. Именно на этом ловятся два компонента, смонтированных в одном
 * коммите React (карточка игрока и таблица лидеров грузят один и тот же
 * недельный рейтинг), и `refreshAppData`, который результат ждёт.
 *
 * Ключ нужен, когда одна функция грузит разные наборы — недельный и
 * месячный рейтинги: запросы с разными ключами друг друга не ждут.
 */
export function singleFlight<A extends unknown[], R>(
  run: (...args: A) => Promise<R>,
  keyOf: (...args: A) => string = () => '',
): (...args: A) => Promise<R> {
  const inFlight = new Map<string, Promise<R>>();

  return (...args: A) => {
    const key = keyOf(...args);
    const running = inFlight.get(key);
    if (running !== undefined) return running;

    const promise = run(...args).finally(() => {
      inFlight.delete(key);
    });
    inFlight.set(key, promise);
    return promise;
  };
}
